import { useNavigate } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

export function useWalletSync() {
    const navigate = useNavigate();
    const loadingEmojiTags = useAppSelector((state) => state.userEmojis.loadingEmojiTags);

    function handleSyncWallet() {
        if (loadingEmojiTags) return;

        navigate('/wallet');
    }

    return handleSyncWallet;
}
